import React from 'react';

export default function Footer() {
  const gitCommit = import.meta.env.VITE_GIT_COMMIT || 'unknown';
  const gitDirty = import.meta.env.VITE_GIT_DIRTY === 'true';

  return (
    <footer className="border-t border-ink-100/70 bg-white/70 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col gap-4 text-sm text-ink-500 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <span className="text-xs uppercase tracking-[0.2em] text-ink-400">Commit</span>
            <code className="rounded-full bg-ink-100 px-3 py-1 font-mono text-xs text-ink-600 shadow-sm">
              {gitCommit}
            </code>
            {gitDirty && (
              <span className="badge-muted">dirty</span>
            )}
          </div>
          <div className="text-xs text-ink-400 sm:text-right">
            © {new Date().getFullYear()} CrossCheckout. Built for mindful grocery planning.
          </div>
        </div>
      </div>
    </footer>
  );
}








